import { FC } from 'react';

import SandCoatingListing from 'components/main/SandCoating';

const SandCoating: FC = () => <SandCoatingListing />;

export default SandCoating;
